import styled, { css } from 'styled-components'

import Skeleton from 'react-loading-skeleton'
import { CustomButton } from '../../../../styles/global'
import { colors } from '../../../../styles/constants'
import { CardSkeleton } from '../../../../components/Card/styles'

const CARD_BOX_SIZES = {
  title: {
    width: '190px',
    height: '19px',
    borderRadius: '8px',
    marginBottom: '4px'
  },
  subtitle: {
    width: '290px',
    height: '17px',
    borderRadius: '8px',
    marginBottom: '16px'
  },
  card: {
    width: '100%',
    height: '74px',
    borderRadius: '12px',
    marginBottom: '16px'
  }
}

export const Container = styled.div`
  width:100%;
  margin:0 auto;
  padding: 0 16px;
  span {
    display: flex;
    justify-content: center;
  }
`

export const CardContainer = styled.div`
  margin-bottom: 16px;
  width: 100%;
  ${({ loading }) => loading && css`
    max-height: 76px;
    span {
      border-radius: 0.75rem;
    }
  `}
  ${CardSkeleton} {
    span {
      min-height: 76px;
    }
  }
`

export const BlockContainer = styled.div`
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 0;
  }
`

export const Block = styled.div`
`

export const Tag = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  height: 24px;
  color: #25B000;
  gap: 5.33px;
  border: 1px solid #25B000;
  border-radius: 8px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 19px;
  padding: 9.33px 4.83px;
  ${({ fill }) => fill && css`
    border: none;
    background-color: #DAF2D4;
  `}
`

export const Label = styled.div`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  display: block;
  color: ${colors.gray.dark};
  margin-top: 8px;
  gap: 5px;
  span{
    font-size: 13px;
    line-height: 19px;
    font-weight: 600;
    white-space: nowrap;
    display: initial;
  }

  ${({ services }) => services && css`
    white-space: pre-wrap;
    display: inline;

    span{
      display: unset;
    }
  `}

`

export const SkeletonCard = styled(Skeleton)`
  width: ${({ type }) => CARD_BOX_SIZES[type].width ?? 'inherit'};
  height: ${({ type }) => CARD_BOX_SIZES[type].height ?? 'inherit'};
  border-radius: ${({ type }) => CARD_BOX_SIZES[type].borderRadius ?? '0'};
  margin-bottom: ${({ type }) => CARD_BOX_SIZES[type].marginBottom ?? '0'};
`

export const LoadMoreButton = styled(CustomButton)`
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 600;
  line-height: 19px;
`

export const Title = styled.div`
  color: ${colors.gray.darker};
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.96px;
  margin-top: 16px;
  ${({ isDisabled }) => isDisabled && `
    color: ${colors.gray.darker};
  `}
`
